"use client";

import { useContext } from "react";
import {
  AccordionDetails,
  AccordionSummary,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import ClientAccordion from "@/stories/SearchDrawerComponents/ClientAccordion";
import { FilterParamsContext } from "@/stories/SearchDrawerComponents/FilterParamsProvider";
import {
  INCOME_MAX_VALUE,
  sliderValueToFilterValue as incomeSliderValueToFilterValue,
  filterValueToSliderValue as incomeFilterValueToSliderValue,
} from "@/stories/SearchDrawerComponents/IncomeSlider";
import {
  sliderValueToFilterValue as populationSliderValueToFilterValue,
  filterValueToSliderValue as populationFilterValueToSliderValue,
} from "@/stories/SearchDrawerComponents/PopulationSlider";
import {
  CITY_POPULATION_MAX_VALUE,
  COUNTY_POPULATION_MAX_VALUE,
} from "@/stories/SearchDrawerComponents/PopulationSlider";
import ValueSlider from "@/stories/SearchDrawerComponents/ValueSlider";

export default function DemographicsDrawer() {
  const { setFilterParams, filterParams } = useContext(FilterParamsContext);

  return (
    <ClientAccordion
      openProperties={[
        "city_income",
        "city_population",
        "county_income",
        "county_population",
      ]}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography component="span" className="font-medium">
          Demographics
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className="flex flex-col gap-6">
          <Typography className="text-sm text-neutral-900 flex items-center gap-1">
            Filter your results using demographic data
            <Tooltip title="Click to learn more about how search works!">
              <IconButton
                size="small"
                href="https://help.cloverleaf.ai/knowledge-base/how-does-search-work"
                target="_blank"
                rel="noopener noreferrer"
                className="text-neutral-500 hover:text-neutral-700"
              >
                <InfoIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Typography>
          <div>
            <Typography className="text-sm font-medium">
              City Population
            </Typography>
            <ValueSlider
              label="City Population"
              value={filterParams.city_population}
              onChange={(newValue) =>
                setFilterParams({
                  ...filterParams,
                  city_population: newValue,
                })
              }
              sliderValueToFilterValue={populationSliderValueToFilterValue}
              filterValueToSliderValue={populationFilterValueToSliderValue}
              max={CITY_POPULATION_MAX_VALUE}
            />
          </div>
          <div>
            <Typography className="text-sm font-medium">
              City Household Income
            </Typography>
            <ValueSlider
              label="City Household Income"
              value={filterParams.city_income}
              onChange={(newValue) =>
                setFilterParams({
                  ...filterParams,
                  city_income: newValue,
                })
              }
              sliderValueToFilterValue={incomeSliderValueToFilterValue}
              filterValueToSliderValue={incomeFilterValueToSliderValue}
              max={INCOME_MAX_VALUE}
              prefix="$"
              minPlaceholder="0"
            />
          </div>
          <div>
            <Typography className="text-sm font-medium">
              County Population
            </Typography>
            <ValueSlider
              label="County Population"
              value={filterParams.county_population}
              onChange={(newValue) =>
                setFilterParams({
                  ...filterParams,
                  county_population: newValue,
                })
              }
              sliderValueToFilterValue={populationSliderValueToFilterValue}
              filterValueToSliderValue={populationFilterValueToSliderValue}
              max={COUNTY_POPULATION_MAX_VALUE}
            />
          </div>
          <div>
            <Typography className="text-sm font-medium">
              County Household Income
            </Typography>
            <ValueSlider
              label="County Household Income"
              value={filterParams.county_income}
              onChange={(newValue) =>
                setFilterParams({
                  ...filterParams,
                  county_income: newValue,
                })
              }
              sliderValueToFilterValue={incomeSliderValueToFilterValue}
              filterValueToSliderValue={incomeFilterValueToSliderValue}
              max={INCOME_MAX_VALUE}
              prefix="$"
              minPlaceholder="0"
            />
          </div>
        </div>
      </AccordionDetails>
    </ClientAccordion>
  );
}
